import React from "react";

export default function Pagination({ pageProps, onPageChange }) {

  const currentPage = pageProps.page;

  const startEntry = (currentPage - 1) * pageProps.entryLimit + 1;
  const endEntry = Math.min(currentPage * pageProps.entryLimit, pageProps.totalEntries);


  return (
    <>{pageProps.totalEntries > 0 ? <>
      <div
        className="dataTables_info"
        id="guestTable-all_info"
        role="status"
        aria-live="polite"
      >
        Showing {startEntry} to {endEntry} of {pageProps.totalEntries} entries
      </div>

      <div
        className="dataTables_paginate paging_simple_numbers"
        id="guestTable-all_paginate"
      >
        {/* Previous */}
        <button
          className={`paginate_button previous ${currentPage === 1 ? "disabled" : ""
            }`}
          aria-controls="guestTable-all"
          data-dt-idx="0"
          tabIndex="0"
          id="guestTable-all_previous"
          onClick={() =>
            currentPage > 1 && onPageChange(currentPage - 1)
          }
        >
          <i className="fa fa-angle-double-left me-3" aria-hidden="true"></i>
          Previous
        </button>

        {/* Page numbers */}
        <span>
          {pageProps.visiblePages.map((page, index) => (
            <button
              key={index}
              className={`paginate_button ${currentPage === page ? "current" : ""
                }`}
              aria-controls="guestTable-all"
              data-dt-idx={index + 1}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          ))}
        </span>

        {/* Next */}
        <button
          className={`paginate_button next ${currentPage === pageProps.totalPages ? "disabled" : ""
            }`}
          aria-controls="guestTable-all"
          data-dt-idx={pageProps.totalPages + 1}
          tabIndex="0"
          id="guestTable-all_next"
          onClick={() =>
            currentPage < pageProps.totalPages && onPageChange(currentPage + 1)
          }
        >
          Next
          <i className="fa fa-angle-double-right ms-3" aria-hidden="true"></i>
        </button>
      </div></> : <></>}
    </>
  );
}